import React, { useRef, useState } from 'react'


import styles from '../../css/style.module.css'


import HOC from '../../components/HOC/HOC'
import { useNavigate } from 'react-router-dom';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import { postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import { RiImageAddLine } from "react-icons/ri";
import { FaPlus } from "react-icons/fa6";



const AddContactDetailsOffice = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [mobilenumber, setMoileNumber] = useState('');;
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');

    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const fileInputRef = useRef(null);






    const handleAdd = async () => {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('mobileNumber', mobilenumber);
        formData.append('email', email);
        formData.append('address', address);
        formData.append('image', image);

        await postApi(endPoints.addcontactoffice, formData, {
            setLoading,
            successMsg: 'Contact Details for office added successfully!',
            errorMsg: 'Failed to add contact Details for office!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/contact-details/office')
        }, 2000);
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleUploadClick = () => fileInputRef.current?.click();

    const handleClearImage = () => {
        setImage(null);
        setImagePreview(null);
    };





    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Added"}
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>Add Contact Details For Office</h6>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={handleAdd}>
                            <FaPlus color='#FFFFFF' />
                            <p>{loading ? "Adding..." : "Add"}</p>
                        </div>
                        <div className={styles.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.addcontactdetails}>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Title*</label>
                            <input
                                type="text"
                                placeholder='Enter the title'
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Mobile Number*</label>
                            <input
                                type="text"
                                placeholder='Enter the mobile number'
                                value={mobilenumber}
                                onChange={(e) => setMoileNumber(e.target.value)}
                            />
                        </div>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Email*</label>
                            <input
                                type="email"
                                placeholder='Enter the email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Address*</label>
                            <input
                                type="text"
                                placeholder='Enter the address'
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                        </div>

                    </div>
                    <div className={styles.addjobinputs}>
                        <label htmlFor="">Description*</label>
                        <textarea
                            placeholder='Enter the description'
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className={styles.addbannercontainer}>
                        <label htmlFor="">Image*</label>
                        <div className={styles.addbannerinput}>
                            {imagePreview ? (
                                <>
                                    <div className={styles.editbannerimage}>
                                        <img src={imagePreview} alt="" />
                                    </div>
                                    <span onClick={handleClearImage}>Clear</span>
                                </>
                            ) : (
                                <>
                                    <div className={styles.addbannerupload} onClick={handleUploadClick}>
                                        <RiImageAddLine color='#8D98AA' size={35} />
                                        <p>Upload your file</p>
                                    </div>
                                    <span>Max 2MB</span>
                                </>
                            )}
                        </div>
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            hidden
                        />
                    </div>
                </div>
            </div >
        </>
    )
}

export default HOC(AddContactDetailsOffice)
